import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

import EditableTable from './KPISettingsTable';

// State management; see DataContext.js
import { useDataSetters, useDataState } from '../../../../DataContext';

const KPISettingsDialog = ({ open, onClose, onSave }) => {
    
    const { 
        plantAssetClasses,
        clickedDashboardTableCell,
        kpiSettingsTable,
    } = useDataState();

    const {
        setKpiSettingsTable,
    } = useDataSetters();

    // useEffect(() => {
    //     if (plantAssetClasses && Array.isArray(plantAssetClasses)) {
    //       const newData = plantAssetClasses.map(vineyard => ({
    //         vineyard_id: vineyard.vineyard_id,
    //         children: vineyard.blocks.map(block => ({
    //           block_id: block.block_id,
    //           yield: block.yield || 'no_data',
    //           cost: block.cost || 'no_data',
    //           revenue: block.revenue || 'no_data'
    //         }))
    //       }));
    //       setKpiSettingsTable(newData);
    //     }
    //   }, [plantAssetClasses]);               
    

    if (!plantAssetClasses) {
        return (
            <Dialog open={open} onClose={onClose} aria-labelledby="settings-dialog-title">
                <DialogTitle id="settings-dialog-title">Settings</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Data is currently unavailable.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    return (
        <Dialog maxWidth='xl' open={open} onClose={onClose} aria-labelledby="settings-dialog-title">
            <DialogTitle id="settings-dialog-title">KPI Settings</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <EditableTable data={kpiSettingsTable} setData={setKpiSettingsTable} />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onSave} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default KPISettingsDialog;
